import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const accordionBackground = `
    background: ${colorsPalettes.sky[100]};
`;

export const AccordionWrapper = styled.div`
    ${accordionBackground}
`;

export const InsightsContentWrapper = styled.div`
    ${accordionBackground}
    padding: 0 32px 16px 24px;
    border-radius: 4px;
`;

export const InsightsContent = styled(FlexColumn)`
    border: 1px solid ${colorsPalettes.carbon[50]};
    background: ${colorsPalettes.carbon[0]};
    padding: 12px 32px;
    border-radius: 4px;
`;

export const InsightsTextWrapper = styled.div`
    margin-bottom: 12px;
`;

export const InsightsText = styled.span`
    ${setFontVariant("body2")}
`;

export const InsightsToggleText = styled.span`
    ${setFontVariant("button", colorsPalettes.blue[400])}
`;

export const ButtonsWrapper = styled(FlexRow)`
    gap: 12px;
`;

export const InsightsLoaderWrapper = styled(FlexColumn)`
    gap: 8px;
`;
